import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        try {
            const baseUrl = window.location.origin;

            // First get CSRF token
            await axios.get(`${baseUrl}/sanctum/csrf-cookie`, {
                withCredentials: true
            });

            // Then check if user is authenticated
            const response = await axios.get(`${baseUrl}/api/admin/check-auth`, {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                }
            });

            if (response.data.user) {
                setUser(response.data.user);
                setIsAuthenticated(true);
            } else {
                setUser(null);
                setIsAuthenticated(false);
            }
        } catch (error) {
            setUser(null);
            setIsAuthenticated(false);
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        try {
            const baseUrl = window.location.origin;
            await axios.post(`${baseUrl}/logout`, {}, {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                }
            });
        } finally {
            setUser(null);
            setIsAuthenticated(false);
            window.location.href = '/login';
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, isAuthenticated, checkAuth, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export default AuthContext;
